import { PersonalAccountSettings } from './PersonalAccountSettings';

export const OnboardingSettingsFormContent = () => <PersonalAccountSettings />;
